import { render, staticRenderFns } from "./Mensagens.vue?vue&type=template&id=472f8fa4"
import script from "./Mensagens.vue?vue&type=script&lang=js"
export * from "./Mensagens.vue?vue&type=script&lang=js"
import style0 from "./Mensagens.vue?vue&type=style&index=0&id=472f8fa4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports